<template>
  <div class="veterinary">
    <div class="veterinary-header">
      <!-- <img :src="typeImg" class="veterinary-header-img"> -->
      <img :src="coursePicture" class="veterinary-header-img">
    </div>
    <div class="veterinary-title">
      <div class="veterinary-title-text">{{courseName}}</div>
      <div class="veterinary-title-time">
        <div class="title-time-left">{{beginTime | timeStr}}开课，共{{videoNum}}小时</div>
        <div class="title-time-right">
          <div class="catalog-title-live" v-if="subscribe" @click="popup">
            <img src="../assets/veterinaryclassimg/check.png">
            <span>已预约</span>
          </div>
          <div class="catalog-title-live" v-else @click="popup">预约直播</div>
        </div>
      </div>
    </div>
    <div class="veterinary-line"></div>
    <div class="veterinary-box">
      <van-tabs v-model="active" sticky @change="tabs">

        <van-tab title="课程概述">
          <div class="overview-box">
            <div class="overview-title">老师介绍</div>
            <div class="overview-teacher">
              <van-swipe :loop="false" :width="170" :show-indicators="false">
                <van-swipe-item v-for="(item,i) in lectuerList" :key="i">
                  <div class="teacher-box">
                    <div class="teacher-img">
                      <img :src="item.lectuerAvator" class="">
                    </div>
                    <div class="teacher-content">
                      <div class="teacher-name">{{item.lectuerName}}</div>
                      <div class="teacher-title">{{item.lectuerTitle}}</div>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="veterinary-line"></div>
            <div class="overview-content">
              <div class="overview-title">课程介绍</div>
              <div class="overview-list">
                <div class="overview-img" v-for="(item,i) in introPictureList" :key="i">
                  <img :src="item.introPicture">
                </div>
              </div>
            </div>
          </div>
        </van-tab>

        <van-tab title="课程目录">
          <div class="catalog-tab" v-if="courseType==2">
            <div class="catalog-tab-flex">
              <div class="tab-flex-box" :class="istab==1?'tabactive':''" @click="tabactive">通关班</div>
            </div>
            <div class="catalog-tab-flex">
              <div class="tab-flex-box" :class="istab==2?'tabactive':''" @click="tabactive">真题讲解班</div>
            </div>
          </div>

          <div class="catalog-list">
            <div class="catalog-box" v-for="(item,i) in videoData" :key="i" @click="popup">
              <div class="catalog-title">
                <div class="catalog-title-text">
                  <span>{{item.videoName}}</span>
                  <img src="../assets/veterinaryclassimg/live.png" v-if="item.videoStatus==2">
                </div>
                <div v-if="item.videoStatus==4" class="catalog-title-tip">观看回放</div>
              </div>
              <div class="catalog-live">
                <div class="catalog-live-text">
                  <b>【直播】</b>
                  <span>{{item.liveBeginTime | timeStr}}</span>
                  <img :src="item.lectuerAvator">
                  <strong>{{item.lectuerName}}</strong>
                  <i v-if="i==0" class="catalog-tip">免费试学</i>
                </div>
              </div>
            </div>
          </div>

        </van-tab>

        <van-tab title="免费试听">
          <div class="video-list">
            <div class="video-title">往期课程</div>
            <div class="video-box" v-for="(item,i) in videoUrl" :key="i" ref="VueAliplayer">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV2" class="va" v-if="isImg==1" :options="item.options"  @play="handleReady(i)" />
                <img class="videoimg" v-else :src="item.videoPicture">
              </div>
              <div class="video-text">{{item.videoName}}</div>
            </div>
          </div>
        </van-tab>

      </van-tabs>
    </div>

    <div class="signup" @click="popup">
      <div class="signup-left">
        <div v-if="specialPrice !== price" class="price-special"><strong><b>¥</b>{{specialPrice}}</strong><span>¥{{price}}</span></div>
        <div v-else class="price">¥<span>{{price}}</span></div>
      </div>
      <div class="signup-right">
        <div class="button">我要报名</div>
      </div>
    </div>

    <van-overlay :show="openPopup" @click="closePopup">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="msgbox">
            <h3>温馨提示</h3>
            <p>更多详细课程</p>
            <p>请下载中科名兽医APP进行查看</p>
            <div class="openapp-button" @click="openApp"><img src="../assets/liveimg/openapp-small.svg"></div>
          </div>
          <div class="old-close" @click="closePopup"><img src="../assets/liveimg/close.svg"></div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import VueAliplayerV2 from 'vue-aliplayer-v2';
import { wxshare } from '@/utils/utils.js'
import { getCourseDetail,getCourseFree,getCourseCatalog } from '@/api/resetApi.js'

export default {
  name: 'veterinary',
  components: {
    VueAliplayerV2: VueAliplayerV2.Player
  },
  data(){
    return{
      active: 0,
      istab: 1,
      isImg: 1,
      openPopup: false,
      classtype: 1,
      typeImg: require('../assets/veterinaryclassimg/back.png'),
      isTop: false,
      placeholder: false,
      look: true,
      player: null,
      options: null,
      courseid: '',
      specialPrice: '',
      price: '',
      courseType: '',
      courseName: '',
      beginTime: '',
      videoNum: '',
      subscribe: '',
      coursePicture: '',
      lectuerList: [],
      introPictureList: [],
      videoData: [],
      videoList1: [],
      videoList2: [],
      videoUrl: [],
      title: '通关系列课',
      desc: '2021年执业兽医资格考试-通关系列课',
      img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/c307aac117f082538e6528d8b3908c9.jpg',
    }
  },
  created(){
    this.courseid = this.$route.query.id
    this.classtype = this.$route.query.type
    this.typeImage()
    this.getCourseDetail()
    this.getCourseCatalog()
    this.getCourseFree()
    wxshare(this.img,this.title,this.desc)
    // console.log('this.$refs.VueAliplayerV21',this.$refs.VueAliplayerV21)
  },
  methods: {
    typeImage() {
      switch (this.courseid) {
        case '3':
          this.typeImg = require('../assets/veterinaryclassimg/qh1.png');
          break;
        case '2':
          this.typeImg = require('../assets/veterinaryclassimg/qh2.png');
          break;
        case '1':
          this.typeImg = require('../assets/veterinaryclassimg/tg1.png');
          break;
        case '4':
          this.typeImg = require('../assets/veterinaryclassimg/tg2.png');
          break;
        case '5':
          this.typeImg = require('../assets/veterinaryclassimg/zt1.png');
          break;
      }
    },
    tabactive() {
      if (this.istab == 1) {
        this.istab = 2
        this.videoData = this.videoList2
      } else {
        this.istab = 1
        this.videoData = this.videoList1
      }
    },
    tabs(){
      if (this.active!==2) {
        this.isImg = 0
      } else {
        this.isImg = 1
      }
    },
    popup() {
      this.tabs()
      this.openPopup = true
      this.isImg = 0
    },
    closePopup() {
      this.openPopup = false
      this.isImg = 1
    },
    openApp() {
      window.location = 'http://t.cn/Aijv8II4'
    },
    // 播放直播
    handleReady(index){
      console.log('1111',index)
      console.log('VueAliplayer',this.$refs.VueAliplayer.length)
      this.$refs.VueAliplayerV2.pause();
      // this.$refs.VueAliplayerV2.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
    },

    async getCourseFree() {
      let data = {
        courseId: this.courseid,
        pageNum:1,
        pageSize:5
      }
      const res = await getCourseFree(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.videoUrl = res.data.data
          let that = this
          that.videoUrl.forEach((item, index) => {
            item.options = {
              width: "100%",
              height: "200px",
              source: that.videoUrl[index].playbackUrl,
              cover: that.videoUrl[index].videoPicture,
              autoplay: false,
              isLive: false,
              rePlay: true,
              playsinline: true,
              preload: true,
              useH5Prism: true,
              disableSeek: true,
              controlBarVisibility: 'click',
              showBarTime: 3000,
              x5_type: 'h5',
              x5_fullscreen: false,
              skinLayout: [
                {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
                {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
                {name: "infoDisplay", align: "cc"},
                {name:"tooltip", align:"blabs",x: 0, y: 56},
                {name: "controlBar", align: "blabs", x: 0, y: 0,
                  children: [
                    {name: "playButton", align: "tl", x: 15, y: 12},
                    {name:"fullScreenButton", align:"tr", x:10, y: 10},
                    {name: "progress", align: "blabs", x: 0, y: 44},
                  ]
                }
              ]
            }
            console.log('item',item)
          })
          console.log('options',this.videoUrl)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },

    async getCourseCatalog() {
      let data = {
        courseId: this.courseid,
      }
      const res = await getCourseCatalog(data)
      // console.log(res,'11111')
      try {
        if (res.data.code === 200) {
          if (res.data.data.length == 1) {
            this.videoData = res.data.data[0].videoList
            // console.log('this.videoList1',this.videoList1)
          } else {
            this.videoData = res.data.data[0].videoList
            this.videoList1 = res.data.data[0].videoList
            this.videoList2 = res.data.data[1].videoList
            // console.log('this.videoList1',this.videoList1)
            // console.log('this.videoList2',this.videoList2)
          }
          // console.log('this.videoList',this.videoList)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },

    async getCourseDetail() {
      let data = new URLSearchParams();
      data.append('courseId',this.courseid)
      const res = await getCourseDetail(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.specialPrice = res.data.data.specialPrice
          this.price = res.data.data.price
          this.subscribe = res.data.data.subscribe
          this.courseType = res.data.data.courseType
          this.beginTime = res.data.data.beginTime
          this.courseName = res.data.data.courseName
          this.videoNum = res.data.data.videoNum
          this.coursePicture = res.data.data.coursePicture
          this.lectuerList = res.data.data.lectuerList
          this.introPictureList = res.data.data.introPictureList
          wxshare(this.img_uri,this.title,)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.prism-player video {
  z-index: 1;
}
.veterinary {
  max-width: 768px;
  margin: 0 auto;
  .veterinary-header {
    width: 3.75rem;
    height: 2.4rem;
    .veterinary-header-img {
      width: 3.75rem;
      height: 2.4rem;
    }
  }
  .veterinary-title {
    padding: 0.15rem;
    background: #fff;
    .veterinary-title-text {
      font-size: 0.2rem;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      text-align: left;
      color: #333333;
    }
    .veterinary-title-time {
      display: flex;
      padding-top: 0.1rem;
      .title-time-left {
        flex: 1;
        align-self: center;
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #9b9b9b;
      }
      .title-time-right {
        flex: 0 0 0.65rem;
        align-self: center;
        .catalog-title-live {
          flex: 0 0 0.65rem;
          align-self: center;
          height: 0.2rem;
          line-height: 0.2rem;
          background: #F5A623;
          border-radius: 0.1rem;
          text-align: center;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #fff;
          img {
            vertical-align: middle;
            width: 0.12rem;
            height: 0.12rem;
          }
        }
      }
    }
  }
  .veterinary-line {
    width: 100%;
    height: 0.1rem;
    background: #f5f5f5;
  }
  .veterinary-box {
    padding-bottom: 0.6rem;
    .van-tabs--line .van-tabs__wrap {
      height: 0.4rem;
    }
    .van-tabs__line {
      background-color: #127BE4;
      width: 0.6rem;
      // border-bottom: 0.03rem solid #127BE4;
    }
    .van-tabs__nav--line {
      // padding-bottom: 0.2rem;
    }
    .van-sticky--fixed {
      width: 3.75rem;
      left: auto;
    }
    .van-tab__text--ellipsis {
      font-weight: bold;
    }
    .van-tab--active {
      color: #127BE4;
    }
    .van-tab {
      line-height: 0.2rem;
      font-size: 0.14rem;
      font-weight: bold;
    } 
    .overview-box {
      .overview-title {
        margin: 0.15rem 0 0 0.15rem;
        padding-left: 0.08rem;
        border-left: 0.03rem solid #127be4;
        font-size: 0.16rem;
        font-weight: 600;
        font-family: PingFangSC, PingFangSC-Medium;
        text-align: left;
        color: #181818;
      }
      .overview-teacher {
        margin-left: 0.15rem;
        padding: 15px 0;
        .teacher-box {
          display: flex;
          font-size: 0;
          width: 160px;
          height: 70px;
          background: #f5f5f5;
          border-radius: 4px;
          .teacher-img {
            flex: 0 0 56px;
            padding: 0 0.05rem 0 0.08rem;
            align-self: center;
            img {
              width: 56px;
              height: 56px;
              border-radius: 50%;
            }
          }
          .teacher-content {
            flex: 1;
            padding-right: 5px;
            align-self: center;
            .teacher-name {
              font-size: 14px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: left;
              color: #181818;
            }
            .teacher-title {
              padding-top: 5px;
              font-size: 10px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: left;
              color: #666666;
            }
          }
        }
      }
      .overview-content {
        .overview-list {
          padding: 0.15rem;
          .overview-img {
            font-size: 0;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .catalog-tab {
      display: flex;
      padding-top: 0.15rem;
      font-size: 0;
      .catalog-tab-flex {
        flex: 1;
        align-self: center;
        .tab-flex-box {
          display: inline-block;
          padding: 0.06rem 0.2rem;
          border: 0.01rem solid #e8e8e8;
          border-radius: 0.16rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
        .tabactive {
          background: #eff6ff;
          border: 0.01rem solid #eff6ff;
          font-weight: 600;
          color: #127be4;
        }
      }
    }
    .catalog-list {
      padding: 0.1rem 0;
      .catalog-box {
        .catalog-title {
          display: flex;
          padding: 0.15rem 0.15rem 0 0.15rem;
          .catalog-title-text {
            flex: 1;
            align-self: center;
            line-height: 0.2rem;
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 600;
            text-align: left;
            color: #181818;
            img {
              margin-left: 0.1rem;
              width: 0.39rem;
              height: 0.14rem;
            }
          }
          .catalog-title-tip {
            flex: 0 0 0.65rem;
            align-self: center;
            height: 0.2rem;
            line-height: 0.2rem;
            background: #f5f5f5;
            border-radius: 0.1rem;
            text-align: center;
            font-size: 0.12rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #999999;
          }
        }
        .catalog-live {
          padding: 0.1rem 0.15rem 0.15rem 0.12rem;
          .catalog-live-text {
            font-size: 0.12rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #666666;
            b {
              vertical-align:middle;
            }
            span {
              margin-right: 0.15rem;
              vertical-align:middle;
            }
            img {
              width: 0.18rem;
              height: 0.18rem;
              vertical-align:middle;
              border-radius: 50%;
            }
            strong {
              margin-left: 0.05rem;
              vertical-align:middle;
            }
            .catalog-tip {
              display: inline-block;
              margin-left: 0.1rem;
              width: 0.5rem;
              height: 0.16rem;
              line-height: 0.16rem;
              text-align: center;
              border: 1px solid #127be4;
              border-radius: 5px;
              font-size: 0.1rem;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              color: #008bf0;
            }
          }
        }
      }
    }

    .video-list {
      padding: 0.15rem;
      .video-title {
        padding-left: 0.08rem;
        border-left: 0.03rem solid #127be4;
        font-size: 0.16rem;
        font-weight: 600;
        font-family: PingFangSC, PingFangSC-Medium;
        text-align: left;
        color: #181818;
      }
      .video-box {
        .video-content {
          padding-top: 0.1rem;
          position: relative;
          .videoimg {
            width: 100%;
            height: 2rem;
          }
          .prism-big-play-btn {
            left: 50% !important;
            bottom: 50% !important;
            margin-left: -0.3rem;
            margin-bottom: -0.3rem;
          }
          .prism-player .prism-big-play-btn {
            background: url(../assets/veterinaryclassimg/play.png) no-repeat;
            background-size: 100% 100%;
            width: 0.6rem;
            height: 0.6rem;
          }
          .prism-player .prism-big-play-btn .outter {
            border: 0;
          }
        }
        .video-text {
          padding: 0.1rem 0;
          font-size: 0.16rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          text-align: left;
          color: #181818;
        }
      }
    }
  }

  .signup {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 3.75rem;
    padding: 0.1rem 0 0.25rem;
    background: #fff;
    z-index: 9999;
    .signup-left {
      flex: 1;
      align-self: center;
      padding-left: 0.15rem;
      .price-special {
        font-size: 0;
        text-align: left;
        strong {
          font-family: PingFangSC, PingFangSC-Semibold;
          font-weight: 600;
          font-size: 0.18rem;
          color: #fb3d3d;
          b {
            font-weight: 600;
            font-size: 0.14rem;
          }
        }
        span {
          padding-left: 0.05rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #999999;
          text-decoration:line-through
        }
      }
      .price {
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #fb3d3d;
        span {
          font-size: 0.18rem;
          font-weight: 600;
        }
      }
    }
    .signup-right {
      flex: 0 0 2rem;
      align-self: center;
      padding-right: 0.15rem;
      .button {
        width: 2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        background: #127BE4;
        border-radius: 0.2rem;
        font-size: 0.18rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
      }
    }
  }

  .van-overlay {
    z-index: 9999;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 0;
    z-index: 9999;
  }

  .block {
    font-size: 0;
    text-align: center;
    .msgbox {
      width: 3rem;
      padding: 0.2rem 0 0.14rem;
      background-color: #fff;
      border-radius: 0.1rem;
      h3 {
        text-align: center;
        font-size: 0.15rem;
        font-weight: bold;
        padding-bottom: 0.2rem;
      }
      p {
        padding-bottom: 0.01rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        font-size: 0.14rem;
        color: #333;
        font-weight: 400;
      }
      .openapp-button {
        display: inline-block;
        padding-top: 0.2rem;
        width: 2.3rem;
        height: 0.54rem;
        img {
          width: 100%;
        }
      }
    }
    .old-close {
      display: inline-block;
      margin-top: 0.2rem;
      width: 0.35rem;
      height: 0.35rem;
      img {
        width: 0.35rem;
        height: 0.35rem;
      }
    }
  }
}
</style>

